import React, { useEffect, useRef } from 'react';
import ReactDOM from "react-dom";
import styles from './FullScreenModal.module.css';

export default function LoadingForm({ containerId }) {
    const containerRef = useRef(null);
    
    useEffect(() => {
        if (containerId) {
            const targetContainer = document.getElementById(containerId);
            if (targetContainer) {
                // Sauvegarder le style position original
                const originalPosition = targetContainer.style.position;
                const computedStyle = window.getComputedStyle(targetContainer);
                
                // Si le container n'a pas de position relative/absolute/fixed, on l'ajoute
                if (computedStyle.position === 'static') {
                    targetContainer.style.position = 'relative';
                    containerRef.current = { element: targetContainer, originalPosition };
                }
            }
        }
        
        return () => {
            // Restaurer le style original au démontage
            if (containerRef.current) {
                containerRef.current.element.style.position = containerRef.current.originalPosition || '';
            }
        };
    }, [containerId]);
    
    // Déterminer le conteneur cible : containerId si fourni, sinon document.body
    const targetContainer = containerId 
        ? document.getElementById(containerId) 
        : document.body;
    
    // Si le containerId est fourni mais l'élément n'existe pas encore, utiliser document.body comme fallback
    const portalTarget = targetContainer || document.body;
    
    return ReactDOM.createPortal(
        <div className={containerId ? styles.modaloverContainer : styles.modalover}>
            <i className={`fas fa-sync fa-spin ${styles.loadingIcon}`}></i>
        </div>,
        portalTarget
    );
}
